import React from 'react';
import { ButtonGroupProps } from '@/shared/types/buttongroup';
import { cn } from '@/shared/utils/cn';

export const ButtonGroup = ({
  children,
  className,
  theme = 'solid',
  color = 'secondary',
  size = 'md',
}: ButtonGroupProps) => {
  const childrenArray = React.Children.toArray(children);

  const processedChildren = React.Children.map(children, (child, index) => {
    if (!React.isValidElement(child)) {
      return child;
    }

    const isFirst = index === 0;
    const isLast = index === childrenArray.length - 1;

    // check if the child has icon and its button
    const hasIcon = child.props.icon;
    // Clonar el elemento hijo y agregar las clases específicas
    return React.cloneElement(child, {
      ...child.props,
      className: `${child.props.className || ''} ${
        isFirst ? '!ui-rounded-r-none' : isLast ? '!ui-rounded-l-none' : '!ui-rounded-none'
      }`.trim(),
      size: child.props.size || size,
      theme: child.props.theme || theme,
      color: child.props.color || 'secondary',
      icon: hasIcon ? child.props.icon : undefined,
    });
  });

  return (
    <div className={cn('ui-imj ui-flex ui-items-center ui-gap-0', className)}>
      {processedChildren}
    </div>
  );
};
